import { useEffect, useMemo, useState } from "react";
import { apiGet, type Conversation } from "../api/client";
import { EmptyMessage } from "../components/EmptyMessage";
import { InboxTable, type InboxRowData } from "../components/InboxRow";
import { PageHeader, PageHeaderAction } from "../components/PageHeader";

export function MessagesPage() {
  const [rows, setRows] = useState<InboxRowData[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    apiGet<Conversation[]>("/conversations")
      .then((conversations) => {
        if (cancelled) return;
        const mapped = (conversations || []).map((c) => {
          const patient =
            c.conversation_participants?.find((p) => p.meta_type === "Patient") ||
            c.patient;
          const last = c.messages_list?.[c.messages_list.length - 1];
          return {
            id: patient?.id || c.patient_id,
            conversation_id: c.id,
            name: patient?.name || "Patient",
            profile_url: patient?.profile_url,
            last_message: last?.body || c.last_message || "",
            time: last?.created_at || c.updated_at || "",
          };
        });
        mapped.sort(
          (a, b) => new Date(b.time).getTime() - new Date(a.time).getTime(),
        );
        setRows(mapped);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const empty = useMemo(() => !loading && rows.length === 0, [loading, rows]);

  return (
    <>
      <PageHeader
        title="Inbox"
        actions={
          <PageHeaderAction
            title="Compose new message"
            icon="ne__icon__add"
            to="/app/compose"
          />
        }
      />

      {loading ? (
        <EmptyMessage>
          <p>Loading messages…</p>
        </EmptyMessage>
      ) : null}

      <div className="ne__conversations">
        {empty ? <EmptyMessage title="No messages" /> : <InboxTable rows={rows} />}
      </div>
    </>
  );
}
